import { validate } from 'graphql';
import { string } from 'prop-types';

export const emailValidation = ({ required }: { required?: string }) => {
	return {
		required: required ? required : false,
		pattern: {
			value: /\S+@\S+\.\S+/,
			message: 'Zadejte e-mail ve formátu jan@novak.cz.',
		},
	};
};

// mozna predelat s pouzitim pattern: {value: 'pattern', message: feedback}:)
export const urlValidation = ({ required, url }: { required?: string | boolean; url: string }) => {
	const validateURL = (value) => {
		if (!required && !value) return true;

		const urlPattern = /^(?:(ftp|http|https):\/\/)?(?:[\w-]+\.)+[a-z]{2,6}(\/[\w-./?%&=]*)?$/;
		return urlPattern.test(value) || url;
	};

	return {
		required: required,
		validate: validateURL,
	};
};

export const urlGoogleMapsValidation = ({
	required,
	url,
}: {
	required?: string | boolean;
	url: string;
}) => {
	const validateURL = (value) => {
		if (!required && !value) return true;

		if (value.includes('maps.app.goo.gl')) {
			return true;
		}

		const urlPattern = /^(https:\/\/)?(www\.)?google\.(com|com\.\w{2,3})\/maps\//;
		return urlPattern.test(value) || url;
	};

	return {
		required: required,
		validate: validateURL,
	};
};

export const timeValidation = (
	{ required }: { required?: string | boolean } = { required: false },
) => {
	const timeMessage = 'Zadejte čas ve formátu hodina:minuta (např. 12:25).';

	const validateTime = (value) => {
		if (!required && !value) return true;

		const urlPattern = /^([01]?\d|2[0-3]):[0-5]\d$/;
		return urlPattern.test(value) || timeMessage;
	};

	return {
		required: required,
		validate: validateTime,
	};
};

export const nonEmptyValidation = (
	{ required }: { required?: boolean | string } = { required: false },
) => {
	const validateSpace = (value: string) => {
		if (!required && !value) return true;

		return value.trim() !== '' || 'Nelze použít pouze mezeru/y.';
	};

	return {
		required: required,
		validate: validateSpace,
	};
};

export const zipValidation = (
	{ required }: { required?: boolean | string } = { required: false },
) => {
	return {
		required: required,
		pattern: { value: /^\d{3}\s?\d{2}\s*$/, message: 'Zadejte PSČ ve formátu 123 45 nebo 12345.' },
	};
};

export const icoValidation = () => {
	return {
		required: 'Zadejte IČO (8místné číslo), na které Vám vystavíme smlouvu.',
		pattern: {
			value: /^\d{8}$/,
			message: 'Zadejte IČO (8místné číslo), na které Vám vystavíme smlouvu.',
		},
	};
};

export const phoneValidation = (
	{ required }: { required?: boolean | string } = { required: false },
) => {
	const validatePhoneNumber = (value) => {
		if (!required) {
			if (!value) {
				return true;
			}

			const numberWithoutPrefix = value.replace(/^\+\d+/, '').replace(/^\s+/, '');

			if (!numberWithoutPrefix) {
				return true;
			}
		}

		const ceskaRegex = /^(\+420) ?[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/;
		const slovenskaRegex = /^(\+421) ?[2-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/;

		// TODO test, ze zacina predcislim -> Zadejte telefonni cislo s predcislim +420 nebo +421.

		const numberPrefix = /^(\+420|00420|0)$/;

		// TODO pak test, ze cislo ma 9 znaku bez predcisli

		// TOHLE JE FULL A MOC HEAVY PRO USER FEEDBACK

		if (ceskaRegex.test(value) || slovenskaRegex.test(value)) {
			return true; // Platné telefonní číslo
		} else {
			return 'Zadejte 9místné číslo (např. 774 200 368).'; // Neplatné telefonní číslo
		}
	};

	return {
		required: required ? 'Zadejte telefonní číslo.' : false,
		validate: validatePhoneNumber,
	};
};
